import { PersonaMessages, useName } from '@bechtel/client-common';
import { AvatarSize, Box, Checkbox, Text, theme } from '@bechtel/gds';
import { CrewMember } from '@bechtel/types';
import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { FieldArray, useFormikContext } from 'formik';
import { findIndex, some } from 'lodash';
import { AvatarRegularStyled, LabelStyled, SubHeaderStyled } from './styled';

export const CrewEmployeeList = () => {
  const { i18n } = useLingui();
  const { getFullName } = useName();
  const { values, isSubmitting, setFieldValue } = useFormikContext();
  const { crewEmployees, selectedCrewEmployees } = values;
  return (
    <Box flexDirection={{ sm: 'column' }} data-testid="crew-employees-section">
      <SubHeaderStyled isSubmitting={isSubmitting}>
        <Box alignItems={{ sm: 'center' }}>
          <Box mr={{ sm: '500' }}>
            <Checkbox
              checked={crewEmployees?.length === selectedCrewEmployees.length}
              indeterminate={selectedCrewEmployees?.length > 0 && selectedCrewEmployees.length < crewEmployees.length}
              onChange={() => {
                if (crewEmployees.length !== selectedCrewEmployees.length) {
                  setFieldValue('selectedCrewEmployees', crewEmployees);
                } else {
                  setFieldValue('selectedCrewEmployees', []);
                }
              }}
              readOnly
            />
          </Box>
          <Text size="400" weight="600" color="grey.1000">
            <Trans>Select All</Trans>
          </Text>
        </Box>
        {selectedCrewEmployees && selectedCrewEmployees.length > 0 && (
          <Text size="400" color="grey.1000">
            {selectedCrewEmployees.length} <Trans>Selected</Trans>
          </Text>
        )}
      </SubHeaderStyled>
      <FieldArray name="selectedCrewEmployees">
        {(arrayHelpers) => {
          return (
            <>
              {crewEmployees &&
                crewEmployees.map((crewEmployee) => {
                  return (
                    <LabelStyled isSubmitting={isSubmitting} key={crewEmployee.id}>
                      <Box mr={{ sm: '500' }}>
                        <Checkbox
                          checked={some(selectedCrewEmployees, (selectedCrew: CrewMember) => {
                            return selectedCrew.id === crewEmployee.id;
                          })}
                          onChange={() => {
                            const selected = findIndex(selectedCrewEmployees, (slectedCrew: CrewMember) => {
                              return slectedCrew.id === crewEmployee.id;
                            });
                            if (selected !== -1) {
                              arrayHelpers.remove(selected);
                            } else {
                              arrayHelpers.push(crewEmployee);
                            }
                          }}
                          readOnly
                        />
                      </Box>
                      <Box flexDirection={{ sm: 'row' }} alignItems={{ sm: 'center' }}>
                        <Box mr={{ sm: '400' }}>
                          <AvatarRegularStyled
                            hasImageUrl={crewEmployee && crewEmployee.imageUrl ? true : false}
                            size={AvatarSize.MEDIUM}
                            src={crewEmployee && crewEmployee.imageUrl ? crewEmployee.imageUrl : undefined}
                          />
                        </Box>
                        <Box
                          css={{ width: '100%' }}
                          justifyContent={{ sm: 'space-between' }}
                          alignItems={{ sm: 'center' }}
                        >
                          <Box flexDirection={{ sm: 'column' }}>
                            <Box css={{ paddingBottom: `${theme.spacings[300]}` }}>
                              <Text weight="600" color="grey.1000" size="400">
                                {getFullName(crewEmployee.firstName, crewEmployee.lastName)}
                              </Text>
                            </Box>
                            <Text size="300" color="grey.600" transform="capitalize">
                              {crewEmployee.persona ? i18n._(PersonaMessages[crewEmployee.persona]) : ''}
                              {crewEmployee?.crew?.crewNumber ? `- ${crewEmployee.crew.crewNumber}` : ''}
                              {crewEmployee.subGroupDescription ? ` / ${crewEmployee.subGroupDescription}` : ''}
                            </Text>
                          </Box>
                        </Box>
                      </Box>
                    </LabelStyled>
                  );
                })}
            </>
          );
        }}
      </FieldArray>
    </Box>
  );
};
